import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import DashboardRoute from './routes/dashboard';
import FlagsRoute from './routes/flags';
import UsersRoute from './routes/users';
import UserDetailRoute from './routes/user-detail';
import PlansRoute from './routes/plans';
import SupportRoute from './routes/support';
import LoginRoute from './routes/login';
import { getAccessToken, setToastInstance } from './api';
import { ToastProvider, useToast } from './toast';
import { DashboardLayout } from './components/layout/dashboard-layout';

function AdminLayout() {
  const authed = Boolean(getAccessToken());
  const location = useLocation();

  if (!authed) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <DashboardLayout>
      <Routes>
        <Route path="/dashboard" element={<DashboardRoute />} />
        <Route path="/users" element={<UsersRoute />} />
        <Route path="/users/:id" element={<UserDetailRoute />} />
        <Route path="/flags" element={<FlagsRoute />} />
        <Route path="/plans" element={<PlansRoute />} />
        <Route path="/support" element={<SupportRoute />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </DashboardLayout>
  );
}

function AppContent(): JSX.Element {
  const toast = useToast();

  useEffect(() => {
    setToastInstance(toast);
  }, [toast]);

  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route path="/*" element={<AdminLayout />} />
    </Routes>
  );
}

export default function App(): JSX.Element {
  return (
    <ToastProvider>
      <AppContent />
    </ToastProvider>
  );
}
